import React from 'react';

const Header = () => 
{
    return (
        <div className="contactPhone">910-297-0929</div>
    )
};

export default Header;